import { DstProductDetailViewModel } from "../interfaces/ProductDetailViewTypes";

const isProductDetailSectionPending = (isPageLoading: boolean): boolean =>
    isPageLoading;

const hasGeneralInformation = (data?: DstProductDetailViewModel): boolean =>
    !!data?.description;

const hasSpecifications = (data?: DstProductDetailViewModel): boolean =>
    !!data?.dimensions || (data?.productAttributes?.length ?? 0) > 0;

const hasBeverages = (data?: DstProductDetailViewModel): boolean =>
    (data?.beverages?.length ?? 0) > 0;

export const showSpecificationInfoSection = (
    data: DstProductDetailViewModel | undefined,
    isPageLoading: boolean,
): boolean =>
    isProductDetailSectionPending(isPageLoading) ||
    hasGeneralInformation(data) ||
    hasSpecifications(data) ||
    hasBeverages(data);

export const showProductSlidersSection = (
    isPageLoading: boolean,
    isAssociationsLoading: boolean,
    accessoriesCount: number,
    similarProductsCount: number,
): boolean =>
    isProductDetailSectionPending(isPageLoading) ||
    isAssociationsLoading ||
    accessoriesCount > 0 ||
    similarProductsCount > 0;

export const showProductCarouselSection = (
    isLoading: boolean,
    imageCount: number,
): boolean => isLoading || imageCount > 0;
